module.exports = __webpack_public_path__ + "static/img/newsLogo.ef14c280.png";